import { Component, EventListener, GondelBaseComponent } from '@gondel/core';
import {
	IValidatableInputComponent,
	ValidatableInputData,
} from '../../../../shared/utils/js/validatable-input.interface';

/**
 * checkbox module implementation.
 * @author Srdan Turudic <srdan.turudic@merkle.com>
 */

enum Selectors {
	InputBox = '.js-a-checkbox__box',
	InputCheckbox = '.js-a-checkbox__input',
}

enum States {
	Error = 'state-a-checkbox--error',
}

@Component('Checkbox')
export class Checkbox extends GondelBaseComponent implements IValidatableInputComponent {
	public _inputCheckbox: HTMLInputElement = {} as HTMLInputElement;

	public start() {
		this._inputCheckbox = this._ctx.querySelector(Selectors.InputCheckbox) as HTMLInputElement;
	}

	/**
	 * Handle click on custom box
	 */
	@EventListener('click')
	public _onClick(): void {
		this._handleState();
	}

	/**
	 * Handle keyboard usage
	 */
	@EventListener('keyup')
	public _onKeyPress(event: KeyboardEvent): void {
		/* Checkbox is focused and key space was clicked */
		if (document.activeElement === this._ctx && event.key === ' ') {
			this._handleState();
		}
	}

	/**
	 * Check/Uncheck box and handle error state
	 */
	public _handleState(): void {
		this._inputCheckbox.checked = !this._inputCheckbox.checked;

		this._isValid();
	}

	public getData(): ValidatableInputData {
		const data = new ValidatableInputData(
			this._inputCheckbox.name,
			this._inputCheckbox.getAttribute('data-value') || 0
		);
		// set the special value of a checkbox in the additional data
		data.additionalValue = this._inputCheckbox.checked;
		return data;
	}

	/**
	 * Handle validation for single checkbox
	 */
	public _isValid() {
		/* Validation single checkboxes */
		if (
			this._inputCheckbox.checked &&
			this._inputCheckbox.hasAttribute('required') &&
			this._ctx.classList.contains(States.Error)
		) {
			this._ctx.classList.remove(States.Error);
			return true;
		} else if (
			!this._inputCheckbox.checked &&
			this._inputCheckbox.hasAttribute('required') &&
			!this._ctx.classList.contains(States.Error)
		) {
			this._ctx.classList.add(States.Error);
			return false;
		}

		return !this._ctx.classList.contains(States.Error);
	}

	public _showValidationErrorsByBe() {
		// this._ctx.classList.add(States.Error);
		// (this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = data.errors.join(' ');
	}
}
